import React from 'react';
import { SanitizedHtml } from './SanitizedHtml';

export const SimPanels = props => {
  return (
    props.cols.map((col, colIndex) => (
      <div key={colIndex} className="d-flex flex-column dinfos-sim__panel-col">

        {!col.panels ? '' : col.panels.map((panel, panelIndex) => {
          if (panel.image && panel.image.src) { 
            return (
              <figure key={panelIndex} className={`dinfos-sim__panel dinfos-sim__panel--cap-${panel.horzAlign} dinfos-sim__panel--cap-${panel.vertAlign}`}>
                <img src={props.assets[panel.image.src]} alt="" data-src={panel.image.src}/>
                {/* Twig template had id. Doesn't look like id was used at all. */}
                {/* <figcaption id={`${id}-panel-{{loop.parent.loop.index}}-{{loop.index}}-cap`}> */} 
                <figcaption>
                  <div>
                  { panel.sr_caption ?
                    <><span className="sr-only">{panel.sr_caption}</span><span aria-hidden="true">{panel.caption}</span></>
                  :
                    panel.caption
                  }
                  </div>
                </figcaption>
              </figure>
            )
          } else if (panel.text) { 
            return (
              <div key={panelIndex} className="dinfos-sim__panel dinfos-sim__panel--text" style={{width:panel.width}}>
                <SanitizedHtml content={panel.text} />
              </div>
            )
          }
          return '';
        })}
      </div>
    ))
  )
}